import * as $ from "jquery";
import "gsap/TweenMax.js";

declare let TweenMax:any;

function playAudio(audioSrc, $clickedObject){
	//remove the old audio                       element on page
	$('#audio-player').off().remove();
	$('.audio__circle').remove();
	$('.js-audio').not($clickedObject).removeClass('state-playing');

	//on click were creating a new audio element with the data-audio-src attribute on the audio icon
	var audioElement = $("<audio />");
	var srcElement = $("<source />");
	$(srcElement).appendTo($(audioElement));
	srcElement.attr({
		src: audioSrc,
		type: "audio/mp3"
	});
	$(audioElement).attr('id', 'audio-player');
	$('body').append(audioElement);

	//setup vars
	var audioPlayer = $('#audio-player')[0];

	//when audio is finished click again to stop it
	audioPlayer.addEventListener('ended', function(){
		$clickedObject.trigger("click");
		$clickedObject.removeClass('state-loading');
	});

	//setup up play and stop options
	if (!$clickedObject.hasClass("state-playing")) {
		$clickedObject.addClass('state-playing');
		audioPlayer.play();

		audioPlayer.addEventListener('loadstart', function() {
			if ($clickedObject.hasClass('state-playing')) {
				$clickedObject.addClass('state-loading');
			}
		});

		audioPlayer.addEventListener('playing', function() {
			$clickedObject.removeClass('state-loading');
		});

		audioPlayer.addEventListener('pause', function() {
			$clickedObject.removeClass('state-loading');
		});

		audioPlayer.addEventListener('loadedmetadata', function() {
			// console.log('Metadata load started');
			if(!$clickedObject.find('.audio__circle').length) {
				$(`<svg class="audio__circle" viewbox="-1 -1 36 36" width="36" height="36" xmlns="http://www.w3.org/2000/svg">
					<circle class="audio__circle-circle" stroke="#fff" stroke-width="2" stroke-dasharray="100" stroke-dashoffset="100" stroke-linecap="round" fill="none" cx="16" cy="16" r="16" />
				</svg>`).prependTo($clickedObject);
			}

			TweenMax.to(document.querySelector('.audio__circle-circle'), audioPlayer.duration, {
				attr:{'stroke-dashoffset': 0},
			});
		});



	} else if ($clickedObject.hasClass("state-playing")) {
		audioPlayer.pause();
		$clickedObject.removeClass('state-playing');
		$('.audio__circle').remove();
	}
}


function initAudioIcons() {
	// this function loops through all the .js-audio elements on a page and setups up a click event to play an mp3 file.
	let $audioIcon = $('.js-audio');

	$audioIcon.each(function(){
		let $this = $(this);
		let src = $this.data('audio-src');

		$this.on('click touch', function(){
			playAudio(src, $this);
		});
	});
}

export function init() {
	if( $('.js-audio').length) {
		initAudioIcons();
	}
}



// WEBPACK FOOTER //
// ./js/PFF/modules/audio.ts